import * as React from "react";
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";
import { connect } from 'react-redux';
import * as actionTypes from '../../../store/actionTypes';

const langs = [
  { label: 'BG', value: 'bg' },
  { label: 'EN', value: 'en' }
];

const langTheme = createMuiTheme({
  overrides: {
    MuiInputBase: {
      root: {
        color: '#3dcd58'
      }
    },
    MuiInput: {
      underline: {
        '&:before': {
          borderBottom: '1px #3dcd58'
        },
        '&:after': {
          borderBottom: '1px #3dcd58'
        },
        '&:hover:before': {
          borderBottom: '1px #3dcd58'
        },
        '&:hover:after': {
          borderBottom: '1px #3dcd58'
        },
      },
    },
    MuiSelect: {
      icon: {
        color: '#3dcd58',
      }
    },
    MuiButtonBase: {
      root: {
        color: '#3dcd58'
      }
    }
  }
}
);

interface IProps {
  onLangChange: any
}

interface IState {
  currentLang: string,
}

class LanguageComponent extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      currentLang: 'bg'
    }
  }

  componentDidMount() {
    let lang = localStorage.getItem('lang');

    if (!lang) {
      localStorage.setItem('lang', 'bg');
    } else {
      this.props.onLangChange(lang);
    }

    this.setState({
      currentLang: localStorage.getItem('lang') + ''
    })
  }

  handleChangeLang = (lang: string) => {
    if (lang) {
      localStorage.setItem('lang', lang);
      this.props.onLangChange(lang);
      this.setState({
        currentLang: lang
      })
    }
    //window.location.reload();
  }

  render() {

    const { currentLang } = this.state;

    return (
      <div className="lang top-right">
        <MuiThemeProvider theme={langTheme}>
          <Select
            value={currentLang}
            onChange={(e: any) => this.handleChangeLang(e.target.value)}
          >
            <MenuItem value={langs[0].value}>{langs[0].label}</MenuItem>
            <MenuItem value={langs[1].value}>{langs[1].label}</MenuItem>
          </Select>
        </MuiThemeProvider>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onLangChange: (lang: any) => dispatch({ type: actionTypes.LANG_CHANGE, lang: lang })
  }
}

export default connect(null, mapDispatchToProps)(LanguageComponent);